// extracted by mini-css-extract-plugin
module.exports = {"container":"HowToUseCashBack_container__d1xny","header":"HowToUseCashBack_header__1Cmxd","rtl":"HowToUseCashBack_rtl__152l3"};